import './Footer.css';

import augiasLogo from '../svg/AUGIAS-DATA-Logo-Einzeiler-weiss-Web.svg';
import manual from '../hb/AUGIAS-Express8.pdf';

function Footer() {
  return (  
    <footer role="contentinfo" className="footer">
      <a target="_blank" className="help-link" href={manual} rel="noreferrer"> 
        Hilfe
        { /*
        <img className="" src={info} alt="" />
        */ }
      </a>
      <a target="_blank" className="augias-link" href="https://www.augias.de" rel="noopener noreferrer"> 
        <img className="" src={augiasLogo} alt="AUGIAS-Data" />
      </a>
      
    </footer>
  );
}

export default Footer;
